<template>
  <l-rows>
    <back-office-form
      :inputs="inputs"
      mode="create"
      :modes="modes"
      @submit="createJurisdiction"
    />
  </l-rows>
</template>

<script>
  import { LRows, } from 'codefabrik-gui-vue'
  import BackOfficeForm from '@/components/BackOfficeForm'
  import { useCreateJurisdiction } from '@/views/casinos/casinoHooks'

  export default {
    name: 'JurisdictionCreate',
    components: { BackOfficeForm, LRows, },
    computed: {
      inputs () {
        return [
          {
            name: 'key',
            validators: 'required',
            properties: {
              label: this.$t('common.key')
            }
          },
          {
            name: 'description',
            validators: 'required',
            properties: {
              label: this.$t('common.description')
            }
          }
        ]
      },
      modes () {
        return {
          create: {
            title: 'masterData.editJurisdiction',
            subtitles: ['']
          },
        }
      }
    },
    mixins: [useCreateJurisdiction()]
  }
</script>

<style scoped>

</style>
